import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MainService } from "../../main.service";
import { MatSnackBar } from "@angular/material";
import { Router } from "@angular/router";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
  passwordForm: FormGroup;
  hideOldPassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;
  ngOnInit(): void {}
  constructor(
    private fb: FormBuilder,
    private mainservice: MainService,
    private _snackBar: MatSnackBar,
    private router: Router
  ) {
    this.passwordForm = this.fb.group(
      {
        oldPassword: ["", [Validators.required, Validators.minLength(8)]],
        newPassword: ["", [Validators.required, Validators.minLength(8)]],
        confirmPassword: ["", Validators.required],
      },
      { validator: this.passwordMatchValidator }
    );
  }

  passwordMatchValidator(form: FormGroup) {
    const newPassword = form.get("newPassword")?.value;
    const confirmPassword = form.get("confirmPassword")?.value;
    return newPassword === confirmPassword ? null : { mismatch: true };
  }

  toggleOldPassword() {
    this.hideOldPassword = !this.hideOldPassword;
  }

  toggleNewPassword() {
    this.hideNewPassword = !this.hideNewPassword;
  }

  toggleConfirmPassword() {
    this.hideConfirmPassword = !this.hideConfirmPassword;
  }

  onSubmit() {
    if (this.passwordForm.valid) {
      let req = this.passwordForm.value;
      delete req["confirmPassword"];
      // let req = {
      //   couponId: this.CouponCode,
      //   bookingDetailId: this.bookingDetail?.bookingDetailId,
      // };
      this.mainservice.changePassword(req).subscribe(
        (res) => {
          //   this.isLoading = false;
          if (res["message"] == "Success") {
            this._snackBar.open("Password change successfully", "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            });
            this.router.navigate(["main/home"]);
            // this.isAppliedCode = true;
            // this.getBookingDetail();
            // console.log(this.bookingDetail, "response");
          }
        },
        (err) => {
          //     this.isLoading = false;
        }
      );
    }
  }
}
